// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"5b0c3248","266":"038162f3","421":"97b52b61","789":"58f183e8","947":"8c65ab8a"}[chunkId] + ".chunk.js";
};